<template>
    <tr class="h-auto border-b border-gray-200">
        <td class="table-cell px-2" @click="emitSelectionEvent">
            <checkbox v-model="isSelected"></checkbox>
        </td>
        <!--Conditionally bind the click handler to only allow clicking the cell if it's contact is archived-->
        <td class="group whitespace-nowrap py-2 pl-2 pr-3 text-sm font-medium flex items-center">
            <!--Web styling-->
            <div class="hidden md:flex items-center flex-nowrap justify-start gap-2"
                 :class="[isArchived ? 'text-gray-300' : 'text-gray-900']">
                <span class="">{{ contact.full_name !== "Unnamed Record" ? contact.full_name : contact.contact_name }}</span>
                <span v-if="isPrimary && !isArchived" :title="'Primary ' + contact.pivot.role">
                    <icon-badge class="h-5 w-5"></icon-badge>
                </span>
            </div>

            <!--Mobile Styling-->
            <div class="block md:hidden">
                <div class="flex items-center flex-nowrap justify-start gap-2" :class="[isArchived ? 'text-gray-300' : 'text-gray-900']">
                    <span class="">{{ contact.full_name !== "Unnamed Record" ? contact.full_name : contact.contact_name }}</span>
                    <icon-badge v-if="isPrimary && !isArchived" class="h-5 w-5" :title="'Primary ' + contact.pivot.role"></icon-badge>
                </div>
                <div class="font-normal" :class="[isArchived ? 'text-gray-300' : 'text-indigo-600']">{{ contact.email }}</div>
                <div class="font-normal" :class="[isArchived ? 'text-gray-300' : 'text-gray-600']">{{ contact.mobile }}</div>
            </div>
        </td>
        <td class="hidden md:table-cell whitespace-nowrap px-3 py-2 text-sm"
            :class="[isArchived ? 'text-gray-300' : 'text-gray-600']">
            {{ contact.email }}
        </td>
        <td class="hidden md:table-cell whitespace-nowrap px-3 py-2 text-sm"
            :class="[isArchived ? 'text-gray-300' : 'text-gray-600']">
            {{ contact.mobile }}
        </td>
    </tr>
</template>

<script>
export default {
    name: "ContactRowNew",
    props: ["contact", "selectedId"],
    data () {
        return {
            isSelected: false
        };
    },
    watch: {
        selectedId (newVal) {
            if (newVal !== this.contact.id) {
                this.isSelected = false;
            }
        }
    },
    computed: {
        isPrimary () {
            return this.contact?.pivot?.primary;
        },
        isArchived () {
            return this.contact?.pivot?.status === "archived";
        },
    },
    methods: {
        emitSelectionEvent () {
            this.$emit("selection-changed", !this.isSelected, this.contact);
        }
    }
};
</script>
